<template>
  <v-container
    :style="{maxWidth: '1000px'}"
  >
    <CropperDialog />

    <ConfirmDialog
      :is-open.sync="dialogs.updateSubtitle.isOpened"
      width="400"
      @confirm="updateSingleField('subtitle', dialogs.updateSubtitle.data.text)"
      @cancel="closeDialog('updateSubtitle')"
    >
      <template v-slot:title>
        Edit subtitle
      </template>
      <template v-slot:body>
        <v-row>
          <v-col
            cols="12"
          >
            <v-textarea
              v-model="dialogs.updateSubtitle.data.text"
              label="Microsite subtitle"
              outlined
              autofocus
            />
          </v-col>
        </v-row>
      </template>
    </ConfirmDialog>

    <v-row
      :style="{
        backgroundColor: 'white',
        position: 'sticky',
        top: '60px',
        zIndex: '2',
        width: '100%',
        margin: '0',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2)',
    }"
    >
      <v-col>
        {{ microsite.title ?  `Title: ${microsite.title}` : ''}}
        {{ microsite.id ?  `ID: ${microsite.id}` : ''}}
      </v-col>
      <v-col>
        <v-btn
          :disabled="!isChangedMicrosite"
          @click="updateMicrosite"
        >Save changes</v-btn>
      </v-col>
      <v-col>
        <v-dialog
          width="600"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              @click="showPreview"
            >
              Show preview
            </v-btn>
          </template>
          <v-sheet
            width="100%"
            min-height="300"
            v-html="micrositePreview"
          >
          </v-sheet>
        </v-dialog>
      </v-col>
    </v-row>

    <v-row
      :style="{marginTop: '10px'}"
    >
      <v-card>
        <v-row>
          <v-col>
            <v-card
          flat
        >
          <v-card-title>
            Subtitle
          </v-card-title>
          <v-card-text>
            <text-card
              :text="microsite.subtitle ? microsite.subtitle : 'empty'"
              v-on:remove="updateSingleField('subtitle', null)"
              v-on:edit="openDialog('updateSubtitle', { text: microsite.subtitle})"
            />
            <translations-bar
              class="my-2"
              :id="microsite.id"
              :translations="translationsSubtitle[microsite.id]
                ? translationsSubtitle[microsite.id] : {}"
              :model="$constants.TRANSLATION_MODELS.MICROSITE_SUBTITLE"
              :title="microsite.subtitle ? microsite.subtitle : ''"
              :trigger-update="microsite.subtitle"
            />
          </v-card-text>
        </v-card>
          </v-col>
          <v-col>
            <v-card
              flat
            >
              <v-card-title>
                Metatags
              </v-card-title>
              <v-card-text>
                <v-textarea
                  v-model="microsite.metatags"
                  @input="isChangedMetatags = true"
                  outlined
                />
                <v-btn
                  color="primary darken-3"
                  small
                  :disabled="true"
                  @click="aiMetatagsGenerate"
                >
                  AI metatags generate
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <RowsList />

      </v-card>

    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import fetchErrorMixin from '../mixins/fetchErrorMixin';
import TranslationsBar from '../components/Translations/TranslationsBar.vue';
import manageDialogsMixin from '../mixins/manageDialogsMixin';
import manageMainItemMixin from '../mixins/manageMainItemMixin';
import RowsList from '../components/DynamicRowList/RowsList.vue';
import CropperDialog from '../components/DynamicRowList/CropperDialog.vue';
import TextCard from '../components/TextCard.vue';
import ConfirmDialog from '../components/dialogs/ConfirmDialog.vue';

export default {
  name: 'MicrositeShow',
  components: {
    ConfirmDialog,
    TextCard,
    TranslationsBar,
    RowsList,
    CropperDialog,
  },

  mixins: [
    fetchErrorMixin,
    manageDialogsMixin,
    manageMainItemMixin,
  ],

  data: () => ({

    manageMainItem: {
      isMultiple: false,
      itemController: 'microsite',
      itemName: 'microsite',
      itemIdentifyField: 'title',
    },

    cardHeight: null,
    microsite: {
      id: null,
      title: null,
      subtitle: null,
      body: [],
    },
    translationsSubtitle: {},
    translationsContents: {},
    isChangedMetatags: false,
    micrositePreview: '',

    dialogs: {
      updateSubtitle: {
        isOpened: false,
        data: {
          text: '',
        },
        defaults: {
          text: '',
        },
      },
    },
  }),

  created() {
    this.fetchData();
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
      setMicrositeBody: 'microsite/setBody',
      markChangesUnsaved: 'microsite/markChangesUnsaved',
      markChangesSaved: 'microsite/markChangesSaved',
      setMicrositeTranslations: 'microsite/setTranslations',
    }),

    async fetchData() {
      await this.$requestHelpers
        .get(`api/admin/microsite/${this.$route.params.id}`)
        .then((response) => {
          this.microsite = response.data.result;
          this.setMicrositeBody(response.data.result.body);

          this.getTranslationsByTypes();
          this.getTranslationsContent();
          this.markChangesSaved();
        });
    },

    getTranslationsByTypes() {
      if (!this.microsite.id) {
        return;
      }

      this.$requestHelpers.post(
        'api/admin/bulk-translations',
        {
          model: this.$constants.TRANSLATION_MODELS.MICROSITE_SUBTITLE,
          ids: [this.microsite.id],
        },
      ).then((response) => {
        this.translationsSubtitle = response.data.result;
      });
    },

    getTranslationsContent() {
      if (!this.microsite.microsite_content) {
        return;
      }

      this.$requestHelpers.post(
        'api/admin/bulk-translations',
        {
          model: this.$constants.TRANSLATION_MODELS.MICROSITE_CONTENT,
          ids: this.microsite.microsite_content.map((item) => item.id),
        },
      ).then((response) => {
        this.setMicrositeTranslations(response.data.result);
      });
    },

    updateFullItemCallback() {
      this.markChangesSaved();
      this.isChangedMetatags = false;
      this.setMicrositeBody(this.microsite.body);

      this.getTranslationsContent();
    },

    updateSingleField(fieldName, fieldValue) {
      this.updateItem(
        {
          id: this.microsite.id,
          [fieldName]: fieldValue,
          _is_single_field_update: true,
          _single_field_value: fieldName,
        },
        this.microsite,
      );
      this.closeDialog('updateSubtitle');
    },

    updateMicrosite() {
      this.cloneItem({ ...this.microsite, body: this.micrositeBody });
      this.updateItem(this.clonedItem, this.microsite, this.updateFullItemCallback);
    },

    aiMetatagsGenerate() {
      console.log('aiMetatagsGenerate');
    },

    showPreview() {
      if (!this.microsite.id) {
        return;
      }

      this.$requestHelpers.post(
        'api/admin/microsite/getHtmlPreview',
        {
          microsite: this.microsite,
        },
      ).then((response) => {
        this.micrositePreview = response.data;
      });
    },
  },

  computed: {
    ...mapGetters({
      standby: 'overlay/show',
      micrositeBody: 'microsite/body',
      isUnsavedChanges: 'microsite/isUnsavedChanges',
    }),

    isChangedMicrosite() {
      return this.isUnsavedChanges || this.isChangedMetatags;
    },
  },
};
</script>
